import React, { useState } from "react";
import useSWR from "swr";
import { fetcher, makeRequest } from "../../utils/request";
import Spinner from "../common/Spinner/Spinner";
import Modal from "../common/Modal";
import { useHistory } from "react-router";

const STATUSES = {
  none: "none",
  cancel: "cancel",
  update: "update",
};

const PlansForm = ({ myPlan }) => {
  const [status, setStatus] = useState(STATUSES.none);
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [error, setError] = useState(false);
  const [chosenPlan, setChosenPlan] = useState(myPlan.id);

  const { data: plans } = useSWR("/api/plans", fetcher, {
    revalidateOnFocus: false,
  });

  if (!plans)
    return (
      <div>
        <Spinner />
      </div>
    );

  const yearPlan = plans.find((i) => i.frequency === "YEAR");
  const monthPlan = plans.find((i) => i.frequency === "MONTH");

  const showConfirmation = () => {
    setShowCancelConfirmation(true);
  };

  const cancelPlan = async () => {
    try {
      setStatus(STATUSES.cancel);
      await makeRequest("delete", "/api/subscriptions");
      setStatus(STATUSES.none);
      window.location = "/cancellation-feedback";
    } catch (err) {
      setError(true);
    }
  };

  const updatePlan = async () => {
    try {
      setStatus(STATUSES.update);
      const res = await makeRequest("post", "/api/subscriptions/update-plan", {
        id: chosenPlan,
      });
      setStatus(STATUSES.none);
      window.location = res.link;
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="w-full">
      {showCancelConfirmation && (
        <Modal onClose={() => setShowCancelConfirmation(false)}>
          {error ? (
            <div>
              <div>
                Something went wrong. Please contact support to resolve this
                issue.
              </div>
            </div>
          ) : (
            <div>
              <div className="text-3xl font-thin">Cancel Plan</div>
              <hr />
              <div className="py-10">
                <p>
                  We know that you’ve seen the value of PMIstandards+, but just
                  in case you change your mind, you can cancel your subscription
                  at any time by choosing “Cancel Plan”. Access to content will
                  be available for the remainder of the current subscription
                  period. The subscription payment is non-refundable. By
                  selecting “Cancel My Plan” this subscription will be canceled
                  and will terminate at the end of your current billing period.
                  You will not be billed again following this termination.
                </p>
              </div>

              <hr />
              <div className="pt-5 flex">
                <div className="w-1/2 mr-5">
                  <button
                    className="w-full block rounded text-center font-normal text-purple-600 hover:bg-purple-100 cursor-pointer text-base sm:text-lg md:text-xl p-5 border border-purple-600"
                    onClick={() => setShowCancelConfirmation(false)}
                  >
                    KEEP MY PLAN
                  </button>
                </div>
                <div className="w-1/2">
                  <button
                    className="w-full block rounded text-center font-normal text-white bg-purple-600 hover:bg-purple-800 cursor-pointer text-base sm:text-lg md:text-xl p-5 border border-purple-600"
                    onClick={cancelPlan}
                  >
                    {status === STATUSES.cancel && (
                      <i className="fas fa-spin fa-spinner mr-3" />
                    )}
                    CANCEL MY PLAN
                  </button>
                </div>
              </div>
            </div>
          )}
        </Modal>
      )}

      {myPlan.id === chosenPlan ? (
        <div
          className="p-5 flex items-center border border-t"
          style={{ minHeight: "100px" }}
        >
          <div className="w-1/3">
            <button
              className="w-full block rounded text-center font-normal bg-gray-100 hover:bg-gray-700 hover:text-white cursor-pointer text-base text-xs p-2 border border-gray-200"
              onClick={showConfirmation}
            >
              END PLAN
            </button>
          </div>
          <div className="ml-3 w-2/3 text-sm">
            By ending your membership you will lose access to your
            PMIstandards+.
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PlansForm;
